import type { TaskFilter } from "types";
import { TaskTypes } from "types";

const TASK_TYPES = Object.values(TaskTypes);

const DEFAULT_VALUES = TASK_TYPES.reduce(
  (acc, type) => ({ ...acc, [type]: true }),
  {} as TaskFilter
);

// The filter is persisted as raw JSON, so a key for a task type that no longer exists outlives the
// release that removed it. Dropped on read rather than tolerated downstream: it would otherwise
// count towards the active-filter badge and be written straight back out on the next change.
const knownTaskTypesOnly = (stored: Record<string, boolean>): Partial<TaskFilter> =>
  Object.fromEntries(
    Object.entries(stored).filter(([key]) => TASK_TYPES.includes(key as TaskTypes))
  );

export const parseTaskFilter = (value: string | null): TaskFilter => ({
  ...DEFAULT_VALUES,
  ...(value ? knownTaskTypesOnly(JSON.parse(value)) : {})
});

export const serializeTaskFilter = (taskFilter: TaskFilter): string =>
  JSON.stringify(taskFilter);

export const countActiveFilters = (taskFilter: TaskFilter): number =>
  TASK_TYPES.reduce((acc, taskType) => acc + (taskFilter[taskType] ? 1 : 0), 0);
